import {gql} from "graphql-request";

export const GetCountry = gql`
  query GetCountry($id:ID!) {
    country(id: $id) {
      name
      trailsCount
      impressionsCount
      boundingBox
      reviewsCount
      polygon {
        id
        boundingPolygon
      }
    }
  }
`;
